<app-base-overlay [title]="title()" [showActionsBorder]="true">
  <div body class="flex min-h-0 flex-1 flex-col gap-3 overflow-hidden">
    @if (isLoading()) {
      <p class="py-10 text-center text-sm text-slate-500">Loading data…</p>
    } @else if (isEmpty()) {
      <p class="py-10 text-center text-sm text-slate-500">
        No rows to preview in this collection.
      </p>
    } @else {
      <div class="min-h-0 flex-1 overflow-auto rounded-xl border border-slate-200">
        <table class="min-w-full border-separate border-spacing-0 text-sm">
          <thead>
            <tr class="text-left">
              @for (column of columns(); track column.key; let first = $first) {
                <th
                  class="sticky top-0 z-10 whitespace-nowrap bg-slate-50 px-3 py-2.5 text-xs font-semibold uppercase tracking-wide text-slate-600"
                  [class.rounded-tl-xl]="first">
                  {{ column.label }}
                </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of rows(); track row.id) {
              <tr class="border-t border-slate-100">
                @for (column of columns(); track column.key) {
                  <td class="whitespace-nowrap px-3 py-2.5 text-slate-800">
                    {{ cellValue(row, column.key) }}
                  </td>
                }
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <div actions class="flex justify-end">
    <lib-signal-button [fullWidth]="false" (clicked)="close()">
      Close
    </lib-signal-button>
  </div>
</app-base-overlay>
